import React from 'react';
import { styled } from '@mui/system';
import Skeleton from '@mui/material/Skeleton';

// Placeholder cards for listing pages. Data fetches can start seconds after
// DOMContentLoaded while the main thread parses the route bundle, and a bare
// LinearProgress over an empty area reads as a broken page. Mirrors the Card
// grid so the layout doesn't jump when real data lands.
const Grid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
  gap: 24,
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr'
  }
}));

const CardBox = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8
}));

const CardGridSkeleton = ({ count = 6 }) => (
  <Grid aria-hidden="true" data-testid="card-grid-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <CardBox key={i}>
        <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2 }} />
        <Skeleton variant="text" width="70%" height={28} />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="85%" />
      </CardBox>
    ))}
  </Grid>
);

export default CardGridSkeleton;
